import { handleTypesName } from "../helpers/function.helper";
export const handleSelectType = [
  { value: 0, label: handleTypesName(0) },
  { value: 100, label: handleTypesName(100) },
  { value: 200, label: handleTypesName(200) },
  { value: 300, label: handleTypesName(300) },
  { value: 400, label: handleTypesName(400) },
  { value: 500, label: handleTypesName(500) },
  { value: 600, label: handleTypesName(600) },
];

export const handleSelectToWarehouse = [
  { value: 0, label: handleTypesName(0) },
  { value: 100, label: handleTypesName(100) },
  { value: 200, label: handleTypesName(200) },
  { value: 300, label: handleTypesName(300) },
  { value: 500, label: handleTypesName(500) },
  { value: 400, label: handleTypesName(400) },
  { value: 401, label: handleTypesName(401) },
  { value: 402, label: handleTypesName(402) },
  { value: 600, label: handleTypesName(600) },
];

export const handleSelectExit = [
  { value: 0, label: handleTypesName(0) },
  { value: 100, label: handleTypesName(100) },
  { value: 200, label: handleTypesName(200) },
  { value: 300, label: handleTypesName(300) },
  { value: 500, label: handleTypesName(500) },
  { value: 400, label: handleTypesName(400) },
  { value: 401, label: handleTypesName(401) },
  { value: 402, label: handleTypesName(402) },
  { value: 600, label: handleTypesName(600) },
];

export const handleSelectType2 = [
  { id: 0, name: handleTypesName(0) },
  { id: 100, name: handleTypesName(100) },
  { id: 200, name: handleTypesName(200) },
  { id: 300, name: handleTypesName(300) },
  { id: 400, name: handleTypesName(400) },
  { id: 401, name: handleTypesName(401) },
  { id: 402, name: handleTypesName(402) },
  { id: 500, name: handleTypesName(500) },
  { id: 600, name: handleTypesName(600) },
];
